<template>
    <div class="bg-amazon-700 mt-24">
        <div class="relative flex justify-end items-center">
            <div class="h-12 w-1/2 max-w-sm bg-background relative rounded-br-3xl">
                <UiLogo
                    class="h-full w-2/3 md:w-1/2 absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center"
                />
            </div>
        </div>
        <div class="-mt-16">
            <UContainer>
                <div class="flex max-md:flex-col pt-16 md:gap-20">
                    <div class="md:w-1/4 max-md:mt-6">
                        <div>
                            <UiComponentTypography variant="subtitle" class-name="text-white">
                                از آخرین تخفیف‌ها باخبر شوید
                            </UiComponentTypography>
                            <WidgetsSubscriptionForm />
                        </div>
                        <div class="mt-8">
                            <UiComponentTypography variant="h6" class="title-underLine text-white">
                                تماس با ما
                            </UiComponentTypography>
                            <div class="mt-4 text-white">
                                <div class="flex items-start gap-2">
                                    <UIcon name="i-solar-map-point-line-duotone" class="w-5 h-5 mt-1 shrink-0" />
                                    <div>
                                        <UiComponentTypography variant="subtitle" class-name="text-white leading-7">
                                            <b>دفتر مرکزی: </b>
                                            خراسان رضوی، مشهد، خیابان احمدآباد، احمدآباد 9 (خیابان نشاط)، ساختمان زمرد،
                                            واحد 101
                                        </UiComponentTypography>
                                        <UiComponentTypography variant="subtitle" class-name="text-white mt-2">
                                            <span class="tracking-widest"> 38411001-38484008 </span>
                                            <span> - 051</span>
                                        </UiComponentTypography>
                                    </div>
                                </div>
                                <div class="flex items-center gap-2 mt-4">
                                    <UIcon name="i-solar-phone-rounded-line-duotone" class="w-5 h-5 mt-1 shrink-0" />
                                    <div>
                                        <UiComponentTypography variant="subtitle" class-name="text-white mt-2">
                                            <b>صدای مشتری: </b>
                                            <span class="tracking-widest px-2"> 09151182005 </span>
                                        </UiComponentTypography>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-8">
                            <UiComponentTypography variant="h6" class="title-underLine text-white">
                                همراه ما باشید
                            </UiComponentTypography>
                            <ul class="mt-4 text-white flex gap-6">
                                <li v-for="item in socials">
                                    <NuxtLink :to="item.link" :aria-label="item.icon" target="_blank" rel="noopener noreferrer">
                                        <UIcon :name="item.icon" dynamic class="w-8 h-8" />
                                    </NuxtLink>
                                </li>
                            </ul>
                        </div>
                        <div class="mt-8">
                            <UiComponentTypography variant="h6" class="title-underLine text-white">
                                نمادها
                            </UiComponentTypography>
                            <div class="mt-4 text-white">
                                <ul class="flex items-center gap-4">
                                    <li class="w-full max-w-1/4 lg:max-w-20">
                                        <NuxtLink
                                            to="/namad"
                                            class="block w-full aspect-square"
                                            aria-label="نماد اعتماد الکترونیکی"
                                            title="نماد اعتماد الکترونیکی"
                                        >
                                            <NuxtImg
                                                class="w-full h-full object-contain"
                                                src="/Images/theme/e-namad_logo.webp"
                                                alt="لوگوی نماد اعتماد الکترونیکی"
                                            />
                                        </NuxtLink>
                                    </li>
                                    <li class="w-full max-w-1/4 lg:max-w-20">
                                        <div class="aspect-square">
                                            <NuxtImg
                                                src="/Images/theme/food_organization_logo.svg"
                                                class="w-full h-full object-contain"
                                            />
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="md:w-2/3 max-md:mt-8">
                        <div>
                            <UiComponentTypography variant="h6" class="title-underLine text-white">
                                لینک‌های مفید
                            </UiComponentTypography>
                            <ul class="mt-4 text-white flex flex-wrap pr-4">
                                <li v-for="item in links" class="w-1/2 mt-2 list-disc">
                                    <NuxtLink :to="item.link">
                                        {{ item.label }}
                                    </NuxtLink>
                                </li>
                            </ul>
                        </div>
                        <div class="mt-8">
                            <UiComponentTypography variant="h6" class="title-underLine text-white">
                                درباره
                                <UiBrandText class-name="text-white" />
                            </UiComponentTypography>
                            <div class="mt-4">
                                <p class="text-white text-justify leading-7 text-sm"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </UContainer>
        </div>
        <div class="mt-16">
            <div
                class="flex max-md:flex-col max-md:items-center justify-between cursor-all-scroll w-2/3 mx-auto bg-white px-6 py-1 rounded-t-2xl max-md:text-center"
            >
                <p class="text-sm">کلیه حقوق این سایت متعلق به شرکت نرس‌لند می‌باشد.</p>
                <p class="text-xs">&copy; کپی‌رایت {{ persianYear }}</p>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
const persianYear = new Intl.DateTimeFormat("fa-IR-u-ca-persian", { year: "numeric" }).format(new Date());

const socials = [
    {
        icon: "i-uil-whatsapp",
        link: "https://wa.me/+989151182005",
    },
    {
        icon: "i-uil-telegram",
        link: "https://t.me/+989151182005",
    },
    {
        icon: "i-uil-instagram",
        link: "https://www.instagram.com/northland.coffee",
    },
];

const links = [
    {
        link: "/",
        label: "صفحه اصلی",
    },
    {
        link: "/about",
        label: "درباره ما",
    },
    {
        link: "/contact",
        label: "تماس با ما",
    },
    {
        link: "/category",
        label: "فروشگاه",
    },
    {
        link: "/terms-and-conditions",
        label: "قوانین و مقررات",
    },
    {
        link: "/privacy-policy",
        label: "حریم خصوصی",
    },
];
</script>

<style scoped>
.title-underLine {
    @apply relative inline-block;
}
.title-underLine::after {
    content: "";
    width: 200%;
    top: 110%;
    @apply absolute h-px bg-amazon-400 right-0;
}
</style>
